import { FC, useEffect } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Field } from "formik";
import { ImportRequestModel } from "../../../../models/ImportRequestModel";


type DetailProps = {
  detail?: ImportRequestModel
  editable?:boolean
  isIncorrect?:boolean
  handleChangeDetail: (e: any) => void
  handleSubmit: () => void
  handleConfirm: () => void
  handleExportPdf: () => void
  handleExportCSV: () => void
  handleShowExportModal: () => void
}

const DetailInfo: FC<DetailProps> = ({
  detail, editable, isIncorrect,
  handleChangeDetail, 
  handleSubmit,
  handleConfirm,
  handleShowExportModal,
  handleExportPdf, 
  handleExportCSV
}) => {
  const intl = useIntl()
  let isConfirmed = detail?.status === 'done';
  return (
    <div className="card-header p-3">
      <div className="col-md-12">
        <div className="row g-3 align-items-center">
          <div className="col-6 col-lg-2">
            <label 
              className="col-form-label">{intl.formatMessage({ id: 'WAREHOUSE.RECEIPT_CODE' })}</label>
          </div>
          <div className="col-6 col-lg-4">
            <strong>{detail?.code}</strong>
          </div>
          <div className="col-6 col-lg-2">
            <label
              className="col-form-label">{intl.formatMessage({ id: 'WAREHOUSE.SUPPLIER' })}</label>
          </div>
          <div className="col-6 col-lg-4">
            <strong>{detail?.sento_supplier?.name || ''}</strong>
          </div>
          <div className="col-12 col-lg-2">
            <label 
              className="col-form-label">Trạng thái</label>
          </div>
          <div className="col-12 col-lg-4">
            <select
              className="form-select"
              disabled={!editable}
              value={detail?.status}
              onChange={(e) => handleChangeDetail(e)}
              name="status"
            >
              <option value="draft">Nháp</option>
              <option value="new">Mới</option>
              <option disabled value="preparing">Đang chuẩn bị</option>
              <option disabled value="shipping">Đang vận chuyển</option>
              <option disabled value="done">Đã hoàn thành</option>
              <option value="canceled">Đã hủy</option>
            </select>
          </div>
          <div className="col-12 col-lg-2">
            <label 
              className="col-form-label">{intl.formatMessage({ id: 'WAREHOUSE.NOTE' })}</label>
          </div>
          <div className="col-12 col-lg-4">
            {detail?.supplier_note !== '' && detail?.supplier_note !== null && (
              <><strong>{detail?.sento_supplier?.name || ''}</strong>: {detail?.supplier_note}<br/></>
            )}
            <Field
                as='textarea'
                className="form-control"
                id="note"
                name="note"
                value={detail?.note || ''}
                onChange={(e: any) => handleChangeDetail(e)}
              />
          </div>
          <div className="btns-group">
              <button 
                className="btn btn-success mb-2 me-1" 
                type="button" 
                onClick={() => handleSubmit()}>Lưu</button>
              {detail?.status === 'shipping' && (
                <button className="btn btn-success mb-2 me-1" type="button" onClick={() => handleConfirm()}>Đã nhận hàng</button>
              )}
              <button className="btn btn-primary mb-2 me-1"
                type="button"
                onClick={() => handleShowExportModal()}> In QrCode
              </button>
              <button className="btn btn-primary mb-2 me-1"
                type="button"
                onClick={() => handleExportPdf()}>{intl.formatMessage({id: 'ORDER.PRINT'})}
                </button>
              <button className="btn btn-primary mb-2 me-1"
                type="button"
                onClick={() => handleExportCSV()}>
                  Tải xuống
              </button>
              <Link to='/warehouse/receipt/import-requests' className="btn btn-primary mb-2 me-1">Quay lại</Link>
          </div>
        </div>
        {(detail?.status === 'shipping' || detail?.is_incorrect_quality === 1 || detail?.is_incorrect_quantity === 1) && (
          <div className="row mt-3">
            <div className="d-flex">
              <label className='form-check form-check-sm form-check-custom form-check-solid ms-0'>
                  <input className='form-check-input'
                      type='checkbox' name='is_incorrect_quantity'
                      disabled={detail?.status !== 'shipping'}
                      checked={detail?.is_incorrect_quantity === 1}
                      onChange={(e) => handleChangeDetail(e)}
                  />
                  <span className='form-check-label'>Giao thiếu</span>
              </label>
              <label className='form-check form-check-sm form-check-custom form-check-solid ms-3'>
                  <input className='form-check-input'
                      type='checkbox'
                      name='is_incorrect_quality'
                      disabled={detail?.status !== 'shipping'}
                      checked={detail?.is_incorrect_quality === 1}
                      onChange={(e) => handleChangeDetail(e)}
                  />
                  <span className='form-check-label'>Không đúng quy cách</span>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default DetailInfo